import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { FDInputRow } from 'Packages/FacetDesign/Components/Experimental/fdInputRow';

const ESPMatchLayout = () => {
  return (
    <FDInputRow>
      <MetaControlField
        attr="matchLevelPercentage"
        CustomProps={{
          helperTextValue: 'Common values are 100% or 50%',
        }}
        flex={1}
      />
      <MetaControlField
        attr="matchPercentage"
        flexGrow={1}
        CustomProps={{
          helperTextValue: 'Usually between 3% and 6%',
        }}
        flex={1}
      />
    </FDInputRow>
  );
};

export default ESPMatchLayout;
